var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSignInWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 700,
    viewBox: "0 0 800 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M800 122C800 122 800 303.516 800 368.928V371.428C770.747 379.516 719.872 390.382 658.143 385.733C580.776 379.9 528.135 352.885 476.488 326.775C512.464 322.603 547.361 315.526 578.298 304.332C606.502 294.133 631.411 280.506 650.843 262.546C673.614 241.503 686.83 217.333 694.229 193.956C752.542 160.547 800 122 800 122Z",
    fill: "#ba7814"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M650.843 262.546C673.614 241.503 686.83 217.333 694.229 193.957C648.438 220.188 596.13 243.253 555.294 241.992C524.676 241.05 471.305 225.18 409.122 206.69C258.33 161.853 55.7157 101.607 0.0529203 201.439C0.144519 220.914 0.0988124 279.871 0.053013 338.948C0.00715188 398.105 -0.0388022 457.381 0.0529203 477.255H800V371.428C688.414 402.281 579.919 379.074 478.319 327.701L476.488 326.776C512.463 322.604 547.361 315.526 578.298 304.333C606.502 294.133 631.411 280.506 650.843 262.546Z",
    fill: "#3b2606"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M799.998 371.428V477.255H0.15625C12.811 443.501 51.0529 356.568 142.241 307.377C205.209 273.407 264.75 272.979 291.976 273.101C370.176 273.457 422.789 299.622 476.486 326.776C580.096 379.154 685.841 402.992 799.998 371.428Z",
    fill: "#faa21b"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignInWave);
export default __webpack_public_path__ + "static/media/signInWave.361c0abab694b34ddd7a43904a129796.svg";
export { ForwardRef as ReactComponent };